<template>
  <div>
    <div class="content-box">
      <p class="p1">
        {{ $t("partner.h1Title1") }}
      </p>
      <p class="p2">{{ $t("partner.h1Title2") }}</p>
      <div class="box1">
        <p class="box-p1">{{ $t("partner.spanVal") }}</p>
        <div class="c-flex mt32 c-flex-space-between">
          <div class="c-flex">
            <div class="box-bj">01</div>
            <div class="c-flex c-flex-column c-flex-space-between">
              <p class="box-p2">{{ $t("partner.spanVal01") }}</p>
              <p class="box-p3">{{ $t("partner.spanVal02") }}</p>
            </div>
          </div>
          <div class="c-flex">
            <div class="box-bj">02</div>
            <div class="c-flex c-flex-column c-flex-space-between">
              <p class="box-p2">{{ $t("partner.spanVal03") }}</p>
              <p class="box-p3">{{ $t("partner.spanVal04") }}</p>
            </div>
          </div>
          <div class="c-flex">
            <div class="box-bj">03</div>
            <div class="c-flex c-flex-column c-flex-space-between">
              <p class="box-p2">{{ $t("partner.spanVal05") }}</p>
              <p class="box-p3">{{ $t("partner.spanVal06") }}</p>
            </div>
          </div>
          <div class="c-flex">
            <div class="box-bj">04</div>
            <div class="c-flex c-flex-column c-flex-space-between">
              <p class="box-p2">{{ $t("partner.spanVal07") }}</p>
              <p class="box-p3">{{ $t("partner.spanVal08") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="box1 mt20">
        <p class="box-p1">{{ $t("partner.becomeMember") }}</p>
        <div class="c-flex c-flex-align-center c-flex-space-between">
          <div v-if="user.vipLevel === 'register'">
            <span class="box-p4">{{ $t("partner.memberTips") }}</span>
          </div>
          <div v-else-if="user.vipLevel === 'member'">
            <!-- <span class="box-p4">{{ $t("partner.memberVip") }}：</span> -->
            <span class="box-p4">{{ $t("partner.memberTips9") }}：</span>
            <!-- <span class="box-p5">
              <span v-if="user.vipLevel === 'member'">
                <img src="@/assets/img/icon_member.png" />
                {{ $t("partner.rwa_member") }}
              </span>
              <span v-else-if="user.vipLevel === 'copartner'">
                <img src="@/assets/img/icon_partner.png" />
                {{ $t("partner.rwa_partner") }}
              </span>
              <span v-else-if="user.vipLevel === 'diamond'">
                <img src="@/assets/img/icon_diamond.png" />
                {{ $t("partner.rwa_diamond") }}
              </span>
            </span> -->
          </div>
          <div class="c-flex">
            <!-- <div class="btn1 mr20">
              <a
                href="https://rwaex.zendesk.com/hc/zh-cn/articles/360033798374"
                target="_blank"
                >{{ $t("partner.btn_detail") }}
              </a>
            </div> -->
            <div
              v-if="user.vipLevel === 'register'"
              class="btn2"
              @click="becomeMemberClick"
            >
              {{ $t("partner.memberTips1") }}
            </div>
            <div v-else class="box-p4">
              {{ $t("partner.memberTips2") }}
            </div>
          </div>
        </div>

        <div class="box-border"></div>
        <p class="box-p1">
          {{ $t("partner.memberTips3") }}
        </p>
        <el-form>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item :label="$t('partner.my_invite_code')">
                <el-input v-model="vipInfo.inviteCode" readonly>
                  <template slot="suffix">
                    <img
                      @click="copyToClipboard(vipInfo.inviteCode)"
                      class="img-copy-icon"
                      src="@/assets/img/images/icon/copy.png"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('partner.my_invite_code_url')">
                <el-input v-model="shareUrl" readonly>
                  <template slot="append">
                    <span @click="copyToClipboard(shareUrl)">{{
                      $t("partner.share_invite_code")
                    }}</span></template
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="box-border"></div>
        <p class="box-p1">
          {{ $t("partner.activity.title") }}
        </p>
        <div v-html="partnerRightsData.content"></div>
        
        <!-- <h4 class="box-p4 mt20"><b>{{ $t("partner.activity.content1") }}</b></h4>
		<p class="box-p4 mt12">{{ $t("partner.activity.content2") }}</p>	
		<p class="box-p4 mt12">{{ $t("partner.activity.content2$1") }}</p>	
		<p class="box-p4 mt12">{{ $t("partner.activity.content2$2") }}</p>
		
		<p class="box-p4 mt12">{{ $t("partner.activity.content2$2$0") }}</p>
		<p class="box-p4 mt12">{{ $t("partner.activity.content2$2$1") }}</p>	
		<p class="box-p4 mt12">{{ $t("partner.activity.content2$2$2") }}</p>	
		
		<h4 class="box-p4 mt20"><b>{{ $t("partner.activity.content3") }}</b></h4>
		<p class="box-p4 mt12">{{ $t("partner.activity.content3$0") }}</p>
		<p class="box-p4 mt12">{{ $t("partner.activity.content3$1") }}</p>
		<p class="box-p4 mt12">{{ $t("partner.activity.content3$2") }}</p>	
		
		<p class="box-p4 mt12">{{ $t("partner.activity.content3$2$0") }}</p>
		<p class="box-p4 mt12">{{ $t("partner.activity.content3$2$1") }}</p>	
		<p class="box-p4 mt12">{{ $t("partner.activity.content3$2$2") }}</p> -->

        <!-- <p class="box-p4 mt12">{{ $t("partner.activity.content4") }}</p>	
		<h4 class="box-p4 mt20">{{ $t("partner.activity.content5") }}</h4>
		<div class="box-p4 mt12">
		  <p><strong>{{ $t("partner.activity.content6") }}</strong></p>
		  <p>{{ $t("partner.activity.content7") }}</p>
		  <p>{{ $t("partner.activity.content8") }}</p>
		  <p>{{ $t("partner.activity.content9") }}</p>
		</div>
		<div class="box-p4 mt12">
		  <p><strong>{{ $t("partner.activity.content10") }}</strong></p>
		  <p>{{ $t("partner.activity.content11") }}</p>
		  <p>{{ $t("partner.activity.content12") }}</p>
		</div>
		<div class="box-p4 mt12">
		  <p><strong>{{ $t("partner.activity.content13") }}</strong></p>
		  <p>{{ $t("partner.activity.content14") }}</p>
		  <p>{{ $t("partner.activity.content15") }}</p>
		</div> -->
        <div class="box-border"></div>
      </div>

      <div class="box1 mt20">
        <p class="box-p1">{{ $t("partner.shareList") }}</p>
        <p class="box-p4 mt20">{{ $t("partner.shareListTips") }}</p>
        <div class="c-flex mt32">
          <!-- <div
            class="c-flex1 c-flex-column c-flex-align-center box-border-right"
          >
            <p class="box-p6">{{ $t("partner.cumulativeRebate") }}</p>
            <p class="mt20">
              <span class="box-p7">{{ vipInfo.rewardFeeSum }}</span>
              <span class="box-p8 ml10">USDT</span>
            </p>
          </div> -->
          <div
            class="c-flex1 c-flex-column c-flex-align-center box-border-right"
          >
            <p class="box-p6">{{ $t("partner.cumulativeCashback") }}</p>
            <p class="mt20">
              <span class="box-p7">{{ vipInfo.rewardWithdrawSum }}</span>
              <span class="box-p8 ml10">USD</span>
            </p>
          </div>
          <div class="c-flex1 c-flex-column c-flex-align-center">
            <p class="box-p6">{{ $t("partner.cumulativeCashback1") }}</p>
            <p class="mt20">
              <span class="box-p7">{{ vipInfo.inviteeNormalSum }}</span>
            </p>
          </div>
        </div>
        <div class="box-border"></div>
        <div class="tab-box">
          <div
            :class="{ sel: tableShow === 'reward_rank' }"
            @click="tabChange('reward_rank')"
          >
            {{ $t("partner.shareTab1") }}
          </div>
          <div
            :class="{ sel: tableShow === 'invite_record' }"
            @click="tabChange('invite_record')"
          >
            {{ $t("partner.shareTab2") }}
          </div>
          <!-- <div
            :class="{ sel: tableShow === 'reward_record' }"
            @click="tabChange('reward_record')"
          >
            {{ $t("partner.shareTab3") }}
          </div> -->
        </div>
        <div v-show="tableShow === 'reward_rank'">
          <el-table
            :data="rewardRankTable"
            style="width: 100%"
            header-cell-class-name="table-head"
            cell-class-name="table-cell"
          >
            <!-- <el-table-column align="center" label="" width="80">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.rank === 1"
                  src="../../assets/img/icon_NO1.png"
                />
                <img
                  v-else-if="scope.row.rank === 2"
                  src="../../assets/img/icon_NO2.png"
                />
                <img
                  v-else-if="scope.row.rank === 3"
                  src="../../assets/img/icon_NO3.png"
                />
              </template>
            </el-table-column> -->
            <el-table-column
              prop="rank"
              align="center"
              :label="$t('partner.rank')"
            >
            </el-table-column>
            <!-- <el-table-column
              prop="vipLevel"
              align="center"
              :label="$t('partner.partner_lvl')"
            >
              <template slot-scope="scope">
                {{ getVipLelStr(scope.row.vipLevel) }}
              </template>
            </el-table-column> -->
            <el-table-column
              prop="userName"
              align="center"
              :label="$t('partner.user')"
            >
            </el-table-column>
            <el-table-column
              prop="inviteeSum"
              align="center"
              :label="$t('partner.invite_amount')"
            >
            </el-table-column>
            <!-- <el-table-column
              align="center"
              :label="$t('partner.reward_cash_total')"
            >
              <template slot-scope="scope">
                {{ scope.row.reward }} USDT
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <div v-show="tableShow === 'invite_record'">
          <el-table
            :data="inviteRecordTable"
            style="width: 100%"
            header-cell-class-name="table-head"
            cell-class-name="table-cell"
          >
            <el-table-column :label="$t('partner.time')">
              <template slot-scope="scope">
                {{
                  dateFormatter(
                    new Date(scope.row.createTime),
                    "yyyy-MM-dd hh:mm:ss",
                  )
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="userId" label="UID">
            </el-table-column>
            <el-table-column
              align="center"
              prop="userName"
              :label="$t('partner.user_invited')"
            >
            </el-table-column>
            <el-table-column
              align="right"
              :label="$t('partner.reward_cash_amount')"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardWithdraw }}&nbsp;USD
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination-box"
            background
            layout="prev, pager, next"
            :total="inviteRecordTotal"
            @current-change="getInviteRecord"
            :current-page.sync="inviteRecordParam.pageNumber"
            :page-size="inviteRecordParam.pageSize"
          />
        </div>

        <div v-show="tableShow === 'reward_record'">
          <el-table
            :data="rewardFeeTable"
            style="width: 100%"
            header-cell-class-name="table-head"
            cell-class-name="table-cell"
          >
            <el-table-column :label="$t('partner.time')">
              <template slot-scope="scope">
                {{
                  dateFormatter(
                    new Date(scope.row.createTime),
                    "yyyy-MM-dd hh:mm:ss",
                  )
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="fromUserName"
              :label="$t('partner.user_invited')"
            >
            </el-table-column>
            <el-table-column
              sortable
              align="right"
              :label="$t('partner.reward_fee_money')"
            >
              <template slot-scope="scope">
                {{ scope.row.amountUsdt }}&nbsp;USD
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination-box"
            background
            layout="prev, pager, next"
            :total="rewardFeeTotal"
            @current-change="getRewardFee"
            :current-page.sync="rewardFeeParam.pageNumber"
            :page-size="rewardFeeParam.pageSize"
          />
        </div>
      </div>
      <div class="box1 mt20">
        <p class="box-p1">{{ $t("partner.questionsTitle") }}</p>
        <div v-html="partnerQasData.content"></div>

        <!-- <p class="box-p6 mt32">{{ $t("partner.questionsVal1") }}</p>
        <p class="box-p4 mt12">{{ $t("partner.questionsVal2") }}</p> -->

        <!-- <div class="box-border2"></div>
        <p class="box-p6">{{ $t("partner.questionsVal3") }}</p>
        <p class="box-p4 mt12">{{ $t("partner.questionsVal4") }}</p>
		
        <div class="box-border2"></div>
        <p class="box-p6">{{ $t("partner.questionsVal5") }}</p>
        <p class="box-p4 mt12">{{ $t("partner.questionsVal6") }}</p> -->

        <!-- <div class="box-border2"></div>
        <p class="box-p6">{{ $t("partner.questionsVal61") }}</p>
        <p class="box-p4 mt12">{{ $t("partner.questionsVal62") }}</p> -->

        <!-- <div class="box-border2"></div>
		<p class="box-p6">{{ $t("partner.questionsVal7") }}</p>
		<p class="box-p4 mt12">
		  {{ $t("partner.questionsVal8") }}<br/>
		  {{ $t("partner.questionsVal81") }}<br/>
		  {{ $t("partner.questionsVal82") }}<br/>
		  {{ $t("partner.questionsVal83") }}
		</p> -->
      </div>
    </div>
    <VFooter />
    <BecomeMember ref="becomeMemberRef" />
    <VerifyAccount ref="verifyAccountRef" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import html2canvas from "html2canvas";
import VFooter from "@/components/footer/VFooter";
import BecomeMember from "@/components/Dialog/BecomeMember";
import VerifyAccount from "@/components/Dialog/VerifyAccount";
export default {
  name: "download",
  components: {
    VFooter,
    BecomeMember,
    VerifyAccount,
  },
  data() {
    return {
      shareUrl: "",
      tableShow: "reward_rank",
      cnyRate: 6,
      vipInfo: {
        newVipLevel: 0,
        vipLevel: "",
        inviteeSum: "- -",
        rewardWithdrawSum: "- -",
        rewardFeeSum: "- -",
        inviteCode: "",
        nextLevelTurnover: null,
        nextLevelInviteeNumber: null,
        nextLevelTurnoverEligible: "- -",
        upRewardFeeRatio: "- -",
        upupRewardFeeRatio: "- -",
        upRewardWithdraw: "- -",
        upupRewardWithdraw: "- -",
        genesis: "- -",
        inviteeNormalSum: "- -",
        inviteLev1Sum: "- -",
        inviteLev2Sum: "- -",
        last24HTradeSum: "- -",
        last24HDoneRewardFeeSum: "- -",
        imgaePosterUrl: "",
        shareUrl: "",
      },
      posterShow: false,
      posterUrl: "",
      rewardRuleData: [],
      ruleData: [],
      tableShow: "reward_rank",
      rewardRankParam: {
        channel: "h5",
        limitCount: 10,
      },
      rewardRankTable: [],
      inviteRecordParam: {
        needPage: 1,
        pageNumber: 1,
        pageSize: 20,
      },
      inviteRecordTotal: 0,
      inviteRecordTable: [],
      rewardFeeParam: {
        needPage: 1,
        pageNumber: 1,
        pageSize: 20,
      },
      rewardFeeTotal: 0,
      rewardFeeTable: [],
      buyInviteCodeFlag: false,
      buyInviteCodeParam: {
        amount: 0,
        password: "",
      },
      buyCard_UID: "",
      success_UID: "",
      buyCardDesc: "",
      checkResult: {
        show: false,
        success: false,
        errorMsg: "",
        username: "",
        name: "",
        followMe: false,
        status: 0,
      },
      checkLoading: false,
      buyCardType: 0,
      buyLoading: false,
      buyInviteCodeSuccessFlag: false,
      memberInviteCode: "",
      inviteCodeTableFlag: false,
      inviteCodeTableParam: {
        needPage: 1,
        pageNumber: 1,
        pageSize: 5,
      },
      inviteCodeTotal: 0,
      inviteCodeTableData: [],
      partnerRightsData: {},
      partnerQasData: {},
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  created() {
    this.getRate();
    this.getRules();
    if (this.user.username && window.localStorage.getItem("jwt-token")) {
      this.getVipInfo();
      this.getDkInfo();
      this.getRewardFee();
      this.getInviteRecord();
      this.getInviteCodeTable();
    }
    this.getNewsList();
    this.getRewardRank();
  },
  mounted() {
    if (document.getElementById("launcher")) {
      document.getElementById("launcher").style.display = "block";
    }
  },
  beforeDestroy() {
    document.getElementById("launcher").style.display = "none";
  },
  methods: {
    tabChange(val) {
      this.tableShow = val;
    },
    memberClick() {
      this.$refs.verifyAccountRef.dialogVisible = true;
    },
    async getNewsList() {
      const partnerRightsRes = await this.$axios.post("/cms/getList", {
        page: 1,
        rows: 12,
        cateCode: "partner-rights",
      });
      if (partnerRightsRes.data.code === this.errorCode.ok) {
        this.partnerRightsData = partnerRightsRes.data.data.rows[0] || {};
      }

      const partnerQasRes = await this.$axios.post("/cms/getList", {
        page: 1,
        rows: 12,
        cateCode: "partner-qas",
      });
      if (partnerQasRes.data.code === this.errorCode.ok) {
        this.partnerQasData = partnerQasRes.data.data.rows[0] || {};
      }
    },
    becomeMemberClick() {
      if (this.user.emailVerify === -1 || this.user.statusGoogle === -1) {
        this.$confirm(
          this.$t("user_center.need_bind1"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("user_center.bind_now"),
            cancelButtonText: this.$t("user_center.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            if (this.user.emailVerify === -1) {
              this.$router.push({ path: "/user" });
            } else {
              this.$router.push({ path: "/user" });
            }
          })
          .catch(() => {});
        return false;
      } else if (this.user.tranPassword === -1) {
        this.$confirm(
          this.$t("user_center.need_tran_password"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("user_center.set_now"),
            cancelButtonText: this.$t("user_center.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({ path: "/user" });
          })
          .catch(() => {});
        return false;
      }
      this.$refs.becomeMemberRef.dialogVisible = true;
    },
    copyToClipboard(val) {
      //注：本地測試不支持該方法
      navigator.clipboard
        .writeText(val)
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t("tipsVal.copySucess"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: this.$t("tipsVal.copyerror"),
          });
        });
    },
    //打开海报
    posterOpen() {
      this.posterShow = true;
      let that = this;
      if (!that.posterUrl) {
        setTimeout(function () {
          html2canvas(that.$refs.img_box, {
            scale: window.devicePixelRatio,
          }).then(function (canvas) {
            that.posterUrl = canvas.toDataURL(); //将canvas转为base64图片(eg. data:image/png;base64)
          });
        }, 100);
      }
    },
    //获取CNY对USDT汇率
    getRate() {
      this.$axios.post("/HomePage/coinCurrencyRate", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          res.data.data.forEach((item) => {
            if (item.legalCurrency === "USDT") {
              this.cnyRate = item.rate;
            }
          });
        }
      });
    },
    //获取规则
    getRules() {
      this.$axios.post("/Copartner/QueryMemberRule", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.rewardRuleData = res.data.data;
          this.ruleData = this.deepCopy(this.rewardRuleData);
          this.ruleData.pop();
          this.rewardRuleData.shift();
        }
      });
    },
    //购买点卡（成为会员）相关信息
    getDkInfo() {
      this.$axios
        .post("/Copartner/QueryDkInfo", { dkType: "normal" })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.buyInviteCodeParam.amount = res.data.data.memberJoinAmount;
            this.buyCardDesc = res.data.data.memberJoinDesc;
          }
        });
    },
    //认证状态
    getStatus(status) {
      switch (status) {
        case 0:
          return this.$t("partner.status_0");
        case 2:
          return this.$t("partner.status_2");
        case 3:
          return this.$t("partner.status_3");
        default:
          return this.$t("partner.status_1");
      }
    },
    //校验UID
    checkUid() {
      if (!this.buyCard_UID) {
        this.$message({
          type: "error",
          message: this.$t("partner.uid_placeholder"),
        });
        return false;
      }
      if (!/^[0-9]*$/.test(this.buyCard_UID)) {
        this.checkResult.show = true;
        this.checkResult.success = false;
        this.checkResult.errorMsg = this.$t("partner.uid_error");
        return false;
      }
      this.checkLoading = true;
      this.$axios
        .post("/Copartner/QueryMCUserInfo", { receiveUserId: this.buyCard_UID })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.checkResult.errorMsg = "";
            this.checkResult.show = true;
            this.checkResult.success = true;
            this.checkResult.username = res.data.data.username;
            this.checkResult.name = res.data.data.name;
            this.checkResult.followMe = res.data.data.followMe;
            this.checkResult.status = res.data.data.status;
          } else {
            this.checkResult.show = true;
            this.checkResult.success = false;
            this.checkResult.errorMsg = res.data.msg;
          }
          this.checkLoading = false;
        })
        .catch((error) => {
          this.checkLoading = false;
        });
    },
    openInviteCodeTableAlert() {
      if (this.user.vipLevel === "") {
        this.$message({
          type: "warning",
          message: this.$t("partner.please_login"),
        });
      } else if (this.user.vipLevel === "register") {
        this.$message({
          type: "warning",
          message: this.$t("partner.must_member"),
        });
      } else {
        this.inviteCodeTableFlag = true;
      }
    },
    openInviteCodeAlert() {
      if (this.user.vipLevel === "") {
        this.$message({
          type: "warning",
          message: this.$t("partner.please_login"),
        });
      } else if (this.user.vipLevel === "register") {
        this.$message({
          type: "warning",
          message: this.$t("partner.must_member"),
        });
      } else if (this.user.tranPassword === -1) {
        this.$confirm(
          this.$t("partner.need_set_password"),
          this.$t("user_center.tip"),
          {
            confirmButtonText: this.$t("partner.set_now"),
            cancelButtonText: this.$t("partner.cancel"),
            type: "warning",
          },
        )
          .then(() => {
            this.$router.push({ path: "/userCenter/setTradePassword" });
          })
          .catch(() => {});
      } else {
        this.buyInviteCodeFlag = true;
      }
    },
    closeBuyInviteCode() {
      this.buyInviteCodeParam.password = "";
      this.buyCard_UID = "";
      this.checkResult = {
        show: false,
        success: false,
        errorMsg: "",
        username: "",
        name: "",
        status: 0,
      };
      this.buyInviteCodeFlag = false;
    },
    //确认购买会员邀请码
    buyInviteCode() {
      if (this.buyCardType === 1) {
        //直升会员
        if (!this.checkResult.show) {
          this.$message({
            type: "error",
            message: this.$t("partner.not_check"),
          });
          return false;
        } else if (!this.checkResult.success) {
          this.$message({
            type: "error",
            message: this.checkResult.errorMsg,
          });
          return false;
        } else {
          this.buyInviteCodeParam.receiveUserId = this.buyCard_UID;
        }
      }
      if (!this.buyInviteCodeParam.password) {
        this.$message({
          type: "error",
          message: this.$t("partner.trade_password_placeholder"),
        });
        return false;
      }
      this.buyLoading = true;
      this.$axios.post("/order/getTranToken", {}).then((res) => {
        this.buyInviteCodeParam.token = res.data.data.token;
        this.$axios
          .post("/Copartner/PurchaseMemberCard", this.buyInviteCodeParam)
          .then((res) => {
            if (res.data.code === this.errorCode.ok) {
              this.memberInviteCode = res.data.data.cardNo;
              this.buyLoading = false;
              this.buyInviteCodeFlag = false;
              this.buyInviteCodeSuccessFlag = true;
              this.getInviteCodeTable(); //刷新已购买的邀请码列表
              this.success_UID = this.buyCard_UID;
              this.buyCard_UID = "";
              this.checkResult = {
                show: false,
                success: false,
                errorMsg: "",
                username: "",
                name: "",
                status: 0,
              };
            } else {
              this.buyLoading = false;
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
            this.buyInviteCodeParam.password = ""; //密码置空
          })
          .catch(() => {
            this.buyLoading = true;
          });
      });
    },
    //获取已买邀请码列表
    getInviteCodeTable() {
      this.$axios
        .post("/Copartner/QueryMemberCard", this.inviteCodeTableParam)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.inviteCodeTableData = res.data.data.cardList;
            this.inviteCodeTotal = res.data.data.total;
          }
        });
    },
    getAlertUrl() {
      switch (this.vipInfo.vipLevel) {
        case "member":
          return require("../../assets/img/be-member-alert.png");
        case "copartner":
          return require("../../assets/img/be-partner-alert.png");
        case "diamond":
          return require("../../assets/img/be-diamond-alert.png");
      }
    },
    getVipInfo() {
      this.$axios.post("/Copartner/QueryCopartnerInfo", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.vipInfo = res.data.data;
          this.shareUrl =
            this.$shareUrl +
            "/#/register?inviteCode=" +
            this.vipInfo.inviteCode;
          // let imgUrl = this.vipInfo.imgaePosterUrl.substring(
          //   this.vipInfo.imgaePosterUrl.indexOf("/static"),
          //   this.vipInfo.imgaePosterUrl.length,
          // );
          // this.vipInfo.imgaePosterUrl = window.location.origin + imgUrl;
        }
      });
    },
    getRewardRank() {
      this.$axios
        .post("/Copartner/QueryRewardCashTopN", this.rewardRankParam)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.rewardRankTable = res.data.data;
          }
        });
    },
    getInviteRecord() {
      this.$axios
        .post("/Copartner/QueryInviteeRecord", this.inviteRecordParam)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.inviteRecordTable = res.data.data.list;
            this.inviteRecordTotal = res.data.data.total;
          }
        });
    },
    getRewardFee() {
      this.$axios
        .post("/Copartner/QueryRewardFeeRecord", this.rewardFeeParam)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            //console.log(res.data.data.feeFlowRecords)
            this.rewardFeeTable = res.data.data.feeFlowRecords;
            this.rewardFeeTotal = res.data.data.total;
          }
        });
    },
    onCopy() {
      this.$message({
        type: "success",
        message: this.$t("partner.copy_success"),
      });
    },
    onError() {
      this.$message({
        type: "error",
        message: this.$t("partner.copy_fail"),
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  position: relative;
  padding: 120px 260px 320px 260px;
  background-color: #f5f6f7;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(~@/assets/img/images/partner-program-bj.png);
  .p1 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 36px;
    color: #333333;
    margin-bottom: 20px;
  }
  .p2 {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #666666;
    margin-bottom: 60px;
  }
  .mt32 {
    margin-top: 32px;
  }
  .box1 {
    width: 100%;
    padding: 32px;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    /deep/.el-input__inner {
      border-radius: 8px 8px 8px 8px;
    }
    .box-p1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 24px;
      color: #333333;
    }
    .box-p2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    .box-p3 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
    }
    .box-p4 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
    }
    .box-p5 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 20px;
      color: #4063ff;
    }
    .box-p6 {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
    }
    .box-p7 {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 24px;
      color: #4063ff;
    }
    .box-p8 {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 14px;
      color: #4063ff;
    }
    .box-border {
      width: 100%;
      height: 1px;
      margin: 32px 0;
      background-color: #e2e3e3;
    }
    .box-border2 {
      width: 100%;
      height: 1px;
      margin: 24px 0;
      background-color: #e2e3e3;
    }
    .box-border-right {
      border-right: 1px solid #e2e3e3;
    }
    .box-bj {
      width: 60px;
      height: 60px;
      margin-right: 20px;
      line-height: 60px;
      text-align: center;
      border-radius: 50%;
      background: #4063ff;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
    }
    .btn1 {
      width: 184px;
      height: 48px;
      cursor: pointer;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #4063ff;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #4063ff;
      text-align: center;
      line-height: 48px;
    }
    .btn2 {
      width: 274px;
      height: 48px;
      cursor: pointer;
      background: #4063ff;
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 48px;
    }
    /deep/ .el-form-item__label {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    /deep/.el-input-group--append {
      gap: 16px;
      display: flex;
    }

    /deep/.el-input-group__append {
      cursor: pointer;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #4063ff;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #4063ff;
      padding: 0 24px;
      width: auto;
      display: flex;
      align-items: center;
    }
    .pagination-box {
      text-align: end;
      margin-top: 60px;
      /deep/ .btn-prev,
      /deep/ .btn-next,
      /deep/ .number {
        width: 44px;
        height: 44px;
        line-height: 44px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 1px rgba(180, 180, 180, 0.06);
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #e2e3e3;
      }
      /deep/ .active {
        background-color: #4063ff !important;
      }
    }
    /deep/.table-head {
      background: rgba(234, 235, 237, 0.5);
    }
    /deep/.table-head:first-child {
      border-radius: 6px 0px 0px 6px;
    }
    /deep/.table-head:last-child {
      border-radius: 0px 6px 6px 0px;
    }
    /deep/.table-cell {
      border: none;
    }
    /deep/ .el-table__body tr.current-row > td {
      background-color: rgba(225, 234, 255, 0.6) !important;
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: rgba(225, 234, 255, 0.6) !important;
    }
    .tab-box {
      gap: 40px;
      display: flex;
      div {
        padding-bottom: 22px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .sel {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 16px;
        color: #4063ff;
        position: relative;
      }
    }
  }
}
.img-copy-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
/deep/ .el-input__suffix {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
</style>
